import { render } from "./dynamicList.vue?vue&type=template&id=74b6bb0a&scoped=true"
import script from "./dynamicList.vue?vue&type=script&lang=js"
export * from "./dynamicList.vue?vue&type=script&lang=js"

import "./dynamicList.vue?vue&type=style&index=0&id=74b6bb0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b6bb0a"]])

export default __exports__